import RestaurantListEmptyMessage from './emptyMessage';

export default RestaurantListEmptyMessage;
